export default {
  title: 'Notifications push',
  description: 'Envoyez des notifications push ciblées à vos clients',
  buttons: {
    new_campaign: 'Nouvelle campagne',
  },
  error_messages: {
    no_mobile_app: {
      title: 'Application mobile pas encore disponible',
      description: "Veuillez attendre que l'application mobile soit disponible avant d'envoyer des notifications push",
    },
  },
};
